(() => {
  if (window.__raCartGiftLastInitialised) return;
  window.__raCartGiftLastInitialised = true;

  let scheduled = false;
  let observer = null;

  const isCartPage = () => document.body.classList.contains('template-cart');

  const hideDuplicate = (element) => {
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
    element.dataset.raGiftDuplicate = 'true';
  };

  const showSelected = (element) => {
    element.hidden = false;
    element.removeAttribute('aria-hidden');
    element.style.removeProperty('display');
    delete element.dataset.raGiftDuplicate;
  };

  const deduplicateGift = () => {
    scheduled = false;
    if (!isCartPage()) return;

    const cart = document.querySelector('#MinimogCart');
    const items = cart?.querySelector('.m-cart__items');
    if (!cart || !items) return;

    const hosts = Array.from(cart.querySelectorAll('.ra-cart-gift-last'));
    let host = hosts[0];

    if (!host) {
      host = document.createElement('div');
      host.className = 'ra-cart-gift-last';
      items.insertAdjacentElement('afterend', host);
    } else if (host.previousElementSibling !== items) {
      items.insertAdjacentElement('afterend', host);
    }

    hosts.slice(1).forEach((extraHost) => extraHost.remove());

    const upsells = Array.from(cart.querySelectorAll('foxkit-incart-upsell'));
    if (!upsells.length) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }

    const selected = upsells.find((element) =>
      element.parentElement === host &&
      (element.childElementCount > 0 || element.textContent.trim())
    ) || upsells.find((element) => element.childElementCount > 0 || element.textContent.trim()) || upsells[0];

    upsells.forEach((element) => {
      if (element === selected) {
        showSelected(element);
      } else {
        hideDuplicate(element);
      }
    });

    if (selected.parentElement !== host) host.replaceChildren(selected);
    else Array.from(host.children).forEach((child) => {
      if (child !== selected) child.remove();
    });

    showSelected(selected);
    host.hidden = false;
  };

  const scheduleDeduplicate = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(deduplicateGift);
  };

  const start = () => {
    if (!isCartPage()) return;
    scheduleDeduplicate();

    const cart = document.querySelector('#MinimogCart');
    if (!cart || cart.dataset.raGiftObserver === 'true') return;
    cart.dataset.raGiftObserver = 'true';

    observer?.disconnect();
    observer = new MutationObserver(scheduleDeduplicate);
    observer.observe(cart, {
      childList: true,
      subtree: true,
      characterData: true
    });

    cart.addEventListener('click', (event) => {
      if (event.target.closest('foxkit-incart-upsell button, .m-quantity__button, m-cart-remove-button')) {
        window.setTimeout(scheduleDeduplicate, 120);
        window.setTimeout(scheduleDeduplicate, 500);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('load', start);
  window.addEventListener('pageshow', start);
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('cart:updated', scheduleDeduplicate);
  document.addEventListener('cart:refresh', scheduleDeduplicate);
})();
